import { MutationConfig, QueryConfig, useMutation, useQuery } from 'react-query';

import {
  ApplyDiscountCodeProps,
  CalculateTaxByAvalaraProps,
  CalculateTaxByAvalaraResponse,
  DiscountCheckout,
  GetCheckoutData,
  GetRetailDetailsResponse,
  RemoveDiscountCodeProps,
  UpdateCheckout,
} from './checkout.types';

export const updatePaymentDetails = ({ client, body, paymentId }: UpdateCheckout) =>
  client.patch(`checkout/${paymentId}`, body).then(({ data }) => data);

export const useUpdatePaymentDetails = (
  options?: MutationConfig<UpdateCheckout, Record<'data', Record<'stack' | 'message', ''>>>,
) => useMutation(updatePaymentDetails, options);

const getRetailDetails = ({ client, paymentId }: GetCheckoutData) =>
  client.get<GetRetailDetailsResponse>(`/retail/${paymentId}`).then(({ data }) => data);

export const useGetRetailDetails = ({
  client,
  paymentId,
  options,
}: GetCheckoutData & {
  options?: QueryConfig<GetRetailDetailsResponse, unknown> | undefined;
}) =>
  useQuery(['getRetailDetails', paymentId], () => getRetailDetails({ client, paymentId }), {
    ...options,
  });

  export const calculateTaxByAvalara = ({ client, body }: CalculateTaxByAvalaraProps) =>
  client.post<CalculateTaxByAvalaraResponse>('herffjones', body).then(({ data }) => data);
export const applyDiscountCode = ({ client, paymentId, code }: ApplyDiscountCodeProps) =>
  client.post<DiscountCheckout>(`checkout/${paymentId}/discount-code`, { code }).then(({ data }) => data);

export const removeDiscountCode = ({ client, paymentId }: RemoveDiscountCodeProps) =>
  client.delete<DiscountCheckout>(`checkout/${paymentId}/discount-code`).then(({ data }) => data);
